import React from "react";
import "react-multi-carousel/lib/styles.css";

import Page from "./Page";

class TwoColumnContentLeftPage extends React.Component
{
  render() {
    return (
        <>
          <Page
            title={this.props.title}
            subtitle={this.props.subtitle}
            content={
              <>
                <div className="container mt-3">
                  <div className="row">
                    <div className="col-12 col-sm-8 col-md-12 col-lg-8 p-0 mb-5 g-font-sarabun">
                      { this.props.leftSide }
                    </div>
                    <div className="col-12 col-sm-4 col-md-12 col-lg-4">
                      {this.props.rightSide}
                    </div>
                  </div>
                </div>
              </>
            }
          />
        </>
    );
  }
}

export default TwoColumnContentLeftPage;
